import server from "@/views/agent_im/server";
import Vip_level from "./components/vip_level";
import Account_status from "./components/account_status";
import Log_record from "./components/log_record";

export default {
    name: "im-userinfo",
    data() {
        return {
            loading: false,
            user_info: {},
            showList: [
                "open_id",
                "role_id",
                "role_name",
                "region_id",
                "system_id",
                "user_type",
                "area_id",
                "area_name",
                "language",
                "channel",
                "network_type",
                "mobile_type",
                "mobile_model",
                "mobile_system",
                "sdk_version",
                "game_version"
            ]
        };
    },
    props: {
        user_id: {
            type: String,
            default: ""
        },
        session_id: {
            type: String,
            default: ""
        }
    },
    created() {
        this.init();
    },
    components: { Vip_level, Account_status, Log_record },
    methods: {
        async init() {
            if (this.user_id || this.session_id) {
                this.loading = true;
                this.user_info = await server.getUserInfo({ user_id: this.user_id, session_id: this.session_id });
                this.loading = false;
            }
        }
    },
    watch: {
        user_id() {
            this.init();
        },
        session_id() {
            this.init();
        }
    }
};
